export const numbers = "1234567890";
export const uppercaseLetters = "QWERTYUIOPASDFGHJKLZXCVBNM";
export const lowerCaseLetters = "qwertyuioppasdfghjklzxcvbnm";
export const specialCharacters = "|,;'/.@#$%^&!*():?_<[<]}+{-~=";
